import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import ThreeSixtyViewer from "../../sidePanel/infoPanel/ThreeSixtyViewer";
import { Image } from "../../../types/airtable";

import "./ImageModalWrapper.scss";

interface Props {
  image: Image | null;
  onClose: () => void;
}

const ImageModalWrapper = ({ image, onClose }: Props) => {
  const [open, setOpen] = useState(false);
  const [is360, setIs360] = useState(false);
  useEffect(() => {
    setOpen(image !== null);
    setIs360(image ? image.is360 : false);
  }, [image]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const renderContent = () => {
    if (image) {
      if (is360) {
        return (
          <div>
            <ThreeSixtyViewer src={image.originalUrl} />
          </div>
        );
      } else {
        return (
          <div>
            <img src={image.originalUrl} />;
          </div>
        );
      }
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="image-modal">
      <div className="img-wrapper">{renderContent()}</div>
    </Modal>
  );
};

export default ImageModalWrapper;
